import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const IExtHostInitDataService = ( createDecorator('IExtHostInitDataService'));
export { IExtHostInitDataService };
